// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");

function fromBool(x) {
  if (x) {
    return "Checked";
  } else {
    return "Unchecked";
  }
}

function toBool(t) {
  switch (t) {
    case "Checked" :
        return true;
    case "Unchecked" :
    case "Indeterminate" :
        return false;
    
  }
}

function isIndeterminate(t) {
  switch (t) {
    case "Checked" :
    case "Unchecked" :
        return false;
    case "Indeterminate" :
        return true;
    
  }
}

function compare(t1, t2) {
  switch (t1) {
    case "Checked" :
        switch (t2) {
          case "Checked" :
              return "Checked";
          case "Unchecked" :
          case "Indeterminate" :
              return "Indeterminate";
          
        }
    case "Unchecked" :
        switch (t2) {
          case "Unchecked" :
              return "Unchecked";
          case "Checked" :
          case "Indeterminate" :
              return "Indeterminate";
          
        }
    case "Indeterminate" :
        return "Indeterminate";
    
  }
}

function reduce(xs) {
  if (xs) {
    return Belt_List.reduce(xs, xs.hd, compare);
  } else {
    return "Unchecked";
  }
}

exports.fromBool = fromBool;
exports.toBool = toBool;
exports.isIndeterminate = isIndeterminate;
exports.reduce = reduce;
/* No side effect */
